import axios from 'axios'

axios.defaults.baseURL = process.env.REACT_APP_BASEURL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

export default axios;



// WEBPACK FOOTER //
// ./src/client/index.js